<template>
  <div class="v-root">
    <div v-loading="viewLoading">
      <div>
        <el-button :type="showSelf?`danger`:'success'" @click="changeShowSelf">{{showSelf?`关闭摄像头`:'开启摄像头'}}</el-button>
        <el-button :type="audioSelf?`danger`:'success'" @click="changeAudio">{{audioSelf?`关闭麦克风`:'开启麦克风'}}</el-button>

      </div>
      <div
        v-loading="callLoading"
        style="display: flex;width:100%;min-height:30vh;max-height: 70vh; display: flex;justify-content: space-around  ">
        <div class="video-c" :id="myVideoViewDomId" v-show="showSelf">

        </div>
        <div class="video-c" :id="herVideoViewDomId">

        </div>
      </div>
    </div>
    <div slot="footer">
      <el-button type="danger" :loading="viewLoading" @click="closeCall">挂断</el-button>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'videoView',
    props: {
      title: {
        type: [String, Number],
        default() {
          return ''
        }
      },
      visibleSync: {
        type: Boolean,
        default: false
      },
      viewLoading: {
        type: Boolean,
        default: false
      },
      herVideoViewDomId: {
        type: String,
        default: new Date().getTime()
      },
      myVideoViewDomId: {
        type: String,
        default: new Date().getTime() + 1
      },
      callLoading:{
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        audioSelf: true,
        showSelf: true
      }
    },
    methods: {
      changeAudio() {
        this.audioSelf = !this.audioSelf
        this.$emit('changeAudio', this.audioSelf)

      },
      changeShowSelf() {
        this.showSelf = !this.showSelf
        this.$emit('changeShowSelf', this.showSelf)
      },
      closeCall() {
        this.$emit('closeCall')
      }
    }
  }
</script>

<style scoped>
  .v-root {
    height: 100%;
    width: 100%;
  }

  .video-c {
    margin: 10px 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/TrtcCall/videoView.vue